import { PHYSICAL_EXAM_SECTION_INITIAL_VALUES } from "./physical-exams";

export const MUSCULOSKELETAL_FORM_INITIAL_VALUES = {
  sections: {
    musculoskeletal: PHYSICAL_EXAM_SECTION_INITIAL_VALUES,
  },
  notes: "",
};

export type PhysicalExamMusculoskeletalSections =
  keyof typeof MUSCULOSKELETAL_FORM_INITIAL_VALUES.sections;
